module.exports = __webpack_public_path__ + "img/1.e9274422.png";